<div
  [ngClass]="{ border: !borderless, color: true, bold: bold }"
  [style.background]="color"
>
  <div class="d-flex confirmation-container">
    <p>{{ confirmation.message }}</p>
    <button class="btn btn-primary" type="button" (click)="onConfirm($event)">
      Confirm
    </button>
  </div>
</div>
